var map = {
	"./about/index.vue": [
		"613f",
		"chunk-13e9a335",
		"chunk-cc9f2850"
	],
	"./about/pigeon.vue": [
		"4e08",
		"chunk-ac137884"
	],
	"./index/404.vue": [
		"52af",
		"chunk-2d0c8078"
	],
	"./index/index.mobile.vue": [
		"9bf0",
		"chunk-13e9a335",
		"chunk-0bc8be90",
		"chunk-8d9e0d94"
	],
	"./index/index.pc.vue": [
		"6c5e",
		"chunk-13e9a335",
		"chunk-0bc8be90",
		"chunk-2a375d87"
	],
	"./index/index_old.vue": [
		"e552",
		"chunk-13e9a335",
		"chunk-251391eb"
	],
	"./index/index_old_1.vue": [
		"d1a4",
		"chunk-13e9a335",
		"chunk-0bc8be90",
		"chunk-2f50ec26"
	],
	"./index/test.vue": [
		"ea2d",
		"chunk-2d22fd04"
	],
	"./news/detail.vue": [
		"f90a",
		"chunk-75d59709"
	],
	"./news/list.vue": [
		"2a621",
		"chunk-13e9a335",
		"chunk-1f9e34a0"
	],
	"./product/index.vue": [
		"e6e2",
		"chunk-79fc79a6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;